// extracted by mini-css-extract-plugin
module.exports = {"cost-saving-S":"S_cost-saving-S__krsRJ"};